import { CartGuards, AirPFPurchaseGuards } from "@hopper-b2b/checkout";

export const Guards = {
  ...AirPFPurchaseGuards,
  ...CartGuards,
};

type IGuardTypes = {
  [K in keyof typeof Guards]: K;
};

export const GuardTypes: IGuardTypes = Object.keys(Guards).reduce(
  (prev, cur) => ({ ...prev, [cur]: cur }),
  {} as IGuardTypes
);
